// Open Razorpay checkout for an order created by our backend and resolve with
// { order_id, payment_id, signature } once paid — via the checkout callback or,
// for UPI Collect, by polling the order status (same rescue path as the
// tournament registration flow). Rejects if the user closes the checkout.
import {
  loadRazorpayScript, buildRazorpayPrefill, withRazorpayCheckoutConfig, pollRazorpayOrderStatus,
} from './razorpay';

export async function payOrder({ order, description, prefill = {} }) {
  await loadRazorpayScript();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  return new Promise((resolve, reject) => {
    let done = false;
    let stopPolling = null;
    const finish = (result) => {
      if (done) return;
      done = true;
      stopPolling?.();
      resolve(result);
    };

    const rzp = new window.Razorpay(withRazorpayCheckoutConfig({
      key: order.key_id,
      amount: order.amount,
      currency: order.currency || 'INR',
      name: 'Backyard',
      description,
      order_id: order.order_id,
      prefill: buildRazorpayPrefill(prefill),
      handler: (response) => finish({
        order_id: order.order_id,
        payment_id: response.razorpay_payment_id,
        signature: response.razorpay_signature,
      }),
      modal: {
        ondismiss: () => {
          if (done) return;
          stopPolling?.();
          reject(new Error('Payment cancelled'));
        },
      },
      theme: { color: '#2B3A67' },
    }));

    stopPolling = pollRazorpayOrderStatus({
      backendUrl,
      orderId: order.order_id,
      onPaid: (info) => {
        try { rzp.close(); } catch { /* already closed */ }
        finish({ order_id: order.order_id, payment_id: info.captured_payment_id, signature: '' });
      },
    });

    rzp.open();
  });
}
